import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import moment from 'moment'
import InputNumberRange from './components/InputNumberRange'
import Upload from './components/Upload'
import IconSelect from './components/IconSelect.vue'
import ShiftTimePicker from './components/ShiftTimePicker'
import { Schema, VDecorator } from './types'
import { Form, Col } from 'ant-design-vue'
import { FormItem } from 'ant-design-vue/types/form/form-item'

@Component
export default class DForm extends Vue {
  @Prop({ default: () => ({ properties: {}, required: [] }) }) schema: Schema
  @Prop({ default: 1 }) cols: number
  @Prop({ default: 8 }) ellipsisLength: number
  @Prop({ default: false }) disabled: Boolean

  formProps: Partial<Form> = {
    form: this.$form.createForm(this, { name: 'd-form' }),
    labelCol: { span: 6 } as Col,
    wrapperCol: { span: 16 } as Col,
  }

  @Emit('selectChange')
  onSelectChange(value: any, option: any, key: string) {
    return { value, option, key }
  }
  @Emit('radioChange')
  onRadioChange(e, key) {
    return { e, key }
  }

  genFormItem(key: string) {
    const { schema, cols, ellipsisLength, disabled} = this
    const { properties, required } = schema
    const { ui, title, readOnly, hidden, hide} = properties[key]
    const {
      labelCol,
      wrapperCol,
      requiredMessage,
      placeholder,
      maxLength,
      isSearch,
      max,
      min,
      mode,
      showSearch,
      showTime,
      disabledDate,
      widget,
      description,
      allowClear,
      filterOption
    } = ui

    let temp: any = null

    if (widget === 'text') {
      return <a-col span={24}>{title}</a-col>
    }

    if (widget === 'divider') {
      return (
        <a-col span={24}>
          <a-divider />
        </a-col>
      )
    }

    const formItemProps: Partial<FormItem> = {
      label: (
        <ellipsis tooltip length={ellipsisLength}>
          {title}
        </ellipsis>
      ),
      labelCol: labelCol || ({ span: 6 } as Col),
      wrapperCol: wrapperCol || ({ span: 16 } as Col),
    }

    const vDecorator: VDecorator = [
      key,
      {
        initialValue: properties[key].default || undefined,
        preserve: false,
        rules: [
          {
            // required: required && (required.includes(key) || required.includes(`extendContent.${key}`)),
            required: true,
            message: requiredMessage || '必填项',
          },
        ],
        trigger: 'change',
        validateFirst: false,
        validateTrigger: 'change',
        valuePropName: 'value',
      },
    ]

    if (typeof widget === 'undefined' || widget === 'input') {
      temp = <a-input v-decorator={vDecorator} placeholder={placeholder} disabled={readOnly} maxLength={maxLength} />
    }

    if (widget === 'textarea') {
      temp = <a-textarea v-decorator={vDecorator} placeholder={placeholder} disabled={readOnly} maxLength={maxLength} />
    }

    if (widget === 'input-number') {
      if (isSearch) {
        vDecorator[1] = {
          ...vDecorator[1],
          initialValue: [0, 10],
        }
        temp = <InputNumberRange v-decorator={vDecorator} />
      } else {
        temp = (
          <a-input-number
            v-decorator={vDecorator}
            placeholder={placeholder}
            min={min || 0}
            max={max || 100}
            disabled={readOnly}
          />
        )
      }
    }

    if (widget === 'select') {
      temp = (
        <a-select
          allowClear={allowClear}
          v-decorator={vDecorator}
          mode={mode || 'default'}
          disabled={readOnly}
          onChange={(v, o) => this.onSelectChange(v, o, key)}
          show-search={showSearch}
          optionFilterProp="children"
          filterOption={showSearch?filterOption:false}
        >
          {properties[key].enum.map(item => {
            return <a-select-option value={item.value}>{item.label}</a-select-option>
          })}
        </a-select>
      )
    }

    if (widget === 'date') {
      if (isSearch) {
        vDecorator[1] = {
          ...vDecorator[1],
          initialValue: [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        }
        temp = <a-range-picker showTime={showTime} v-decorator={vDecorator} disabled={readOnly} />
      } else {
        temp = (
          <a-date-picker showTime={showTime} v-decorator={vDecorator} disabled={readOnly} disabledDate={disabledDate} />
        )
      }
    }

    if (widget === 'radio') {
      temp = (
        <a-radio-group v-decorator={vDecorator} disabled={readOnly} onChange={e => this.onRadioChange(e, key)}>
          {properties[key].enum.map(item => {
            return <a-radio value={item.value}>{item.label}</a-radio>
          })}
        </a-radio-group>
      )
    }

    if (widget === 'switch') {
      vDecorator[1].valuePropName = 'checked'
      temp = (
        <a-form-item>
          <a-switch v-decorator={vDecorator} disabled={readOnly} />
        </a-form-item>
      )
    }

    if (widget === 'upload') {
      vDecorator[1] = {
        ...vDecorator[1],
        valuePropName: 'fileList',
        // getValueFromEvent: this.normFile,
      }
      temp = <Upload v-decorator={vDecorator} />
    }

    if (widget === 'icon-select') {
      temp = <IconSelect v-decorator={vDecorator} />
    }

    if (widget === 'shift-time-picker') {
      temp = <ShiftTimePicker v-decorator={vDecorator} />
    }

    return (
      <a-col span={ui.span || 24 / cols}>
        <a-form-item
          label={formItemProps.label}
          labelCol={formItemProps?.labelCol}
          wrapperCol={formItemProps?.wrapperCol}
          help={description}
          style={{ display: hidden ? 'none' : 'block' }}
        >
          {temp}
        </a-form-item>
      </a-col>
    )
  }

  render() {
    const { schema, formProps } = this
    const { properties } = schema
    const keys = Object.keys(properties)
    console.log('passssssssssssssss,',keys)
    return (
      <a-form form={formProps.form} labelCol={formProps.labelCol} wrapperCol={formProps.wrapperCol}>
        <a-row>
          {keys.map(key => {
            const item = this.genFormItem(key)
            return item
          })}
        </a-row>
      </a-form>
    )
  }
}
